import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { bannersRotativos } from '../mock';

const BannersRotativos = () => {
  const [currentBanner, setCurrentBanner] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % bannersRotativos.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const nextBanner = () => {
    setCurrentBanner((prev) => (prev + 1) % bannersRotativos.length);
  };

  const prevBanner = () => {
    setCurrentBanner((prev) => (prev - 1 + bannersRotativos.length) % bannersRotativos.length);
  };

  return (
    <section className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative">
          <div className="overflow-hidden rounded-xl border border-gray-200 shadow-lg">
            <div className="relative h-[300px] md:h-[400px]">
              {bannersRotativos.map((banner, index) => (
                <div
                  key={banner.id}
                  className={`absolute inset-0 transition-opacity duration-700 ${
                    index === currentBanner ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  <div className="relative h-full">
                    <img
                      src={banner.imagen}
                      alt={banner.titulo}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" />
                    
                    <div className="absolute inset-0 flex items-center">
                      <div className="w-full max-w-3xl px-8 md:px-16">
                        <h3 className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight">
                          {banner.titulo}
                        </h3>
                        <p className="text-gray-100 text-lg mb-6">
                          {banner.descripcion}
                        </p>
                        <button className="px-8 py-3 bg-[#8B1538] text-white rounded-lg hover:bg-[#6B0F2A] transition-colors font-medium inline-flex items-center gap-2">
                          Ver más
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Navigation Buttons */}
            <button
              onClick={prevBanner}
              className="absolute left-4 top-1/2 -translate-y-1/2 p-3 bg-white/90 hover:bg-white rounded-full shadow-lg transition-all backdrop-blur-sm z-10"
            >
              <ChevronLeft className="h-6 w-6 text-gray-800" />
            </button>
            <button
              onClick={nextBanner}
              className="absolute right-4 top-1/2 -translate-y-1/2 p-3 bg-white/90 hover:bg-white rounded-full shadow-lg transition-all backdrop-blur-sm z-10"
            >
              <ChevronRight className="h-6 w-6 text-gray-800" />
            </button>

            {/* Indicators */}
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-10">
              {bannersRotativos.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentBanner(index)}
                  className={`h-2 rounded-full transition-all ${
                    index === currentBanner ? 'w-8 bg-[#8B1538]' : 'w-2 bg-white/70'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannersRotativos;